import { memo, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuraLayout, Layout, PageTitle, AddCardIcon } from "lola-framework-ui-test";

import { FlowHeroMark } from "../../components/FlowHeroMark";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { REQUEST_ROUTES, TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";
import { useComposeStore } from "../../store/useComposeStore";
import { PayoutMethodType } from "../../interfaces/payout";
import { requestEstimateOptions } from "../../gallery/requestMock";

/**
 * Gallery-safe add-card processing: short delay, seed compose.selection, return
 * to Transfer (no VGS / pre-validate network).
 */
export const AddCardProcessingPage = memo(() => {
  const { t } = useTranslation("request");
  const { theme } = useStore();
  const setSelection = useComposeStore((s) => s.setSelection);
  const navigate = useNavigate();
  const colorConfig = theme.whiteView;
  const { dropzoneColors, backgroundIcon } = colorConfig;
  const advancedRef = useRef(false);

  useEffect(() => {
    if (advancedRef.current) return;
    advancedRef.current = true;
    const timer = setTimeout(() => {
      const option =
        requestEstimateOptions.find(
          (o) => o.payoutMethod === PayoutMethodType.PUSH_TO_CARD
        ) ?? null;
      setSelection({
        method: PayoutMethodType.PUSH_TO_CARD,
        option,
        payout: {
          source: "new",
          brand: "VISA",
          last4: "1111",
          cardExpiry: "09/29",
          cardholderName: "Maria Lopez",
        },
      });
      navigate(REQUEST_ROUTES.TRANSFER, { replace: true });
    }, 1600);
    return () => clearTimeout(timer);
  }, [navigate, setSelection]);

  return (
    <AuraLayout colorConfig={colorConfig} className="flow-landing-page">
      <Layout.Content className="landing-section flow-hero-section">
        <ScrollFadeIndicator color={colorConfig.bodyCopy} />
        <section className="flow-hero">
          <FlowHeroMark
            showSpinner
            dropzoneColors={dropzoneColors}
            backgroundIcon={backgroundIcon}
          >
            <AddCardIcon size={60} colors={dropzoneColors} />
          </FlowHeroMark>
          <section className="landing-container">
            <PageTitle
              highlight={t("card.addingCard")}
              highlightColor={TITLE_COLOR}
              secudnary={t("card.pleaseWait")}
              secudnaryColor={TITLE_COLOR}
            />
          </section>
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
